import { useQuery } from 'react-query';
import { WDAC_MANAGED_INSTALLER_TAB_COUNTS_KEY } from '../../constants/query';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import ManagedInstallerService from '../../services/managed-installer.service';

const useGetManagedInstallersTabCounts = ({ managedInstallerId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery([WDAC_MANAGED_INSTALLER_TAB_COUNTS_KEY, managedInstallerId, customerEnvId], () =>
    ManagedInstallerService.getManagedInstallersTabCounts({ managedInstallerId, customerEnvId }),
  );
};

export default useGetManagedInstallersTabCounts;